var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconAndroidFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.653 0l11.755 11.693 3.223-3.23L3.383.222A1.557 1.557 0 002.653 0zM1.67.544c-.106.189-.17.412-.17.663v22.722c0 .183.038.347.102.493l12.026-11.964L1.67.544zm16.945 8.48l-3.444 3.434 3.444 3.416 4.206-2.414c.598-.346.683-.786.679-1.02-.007-.386-.25-.747-.662-.968-.358-.194-3.019-1.746-4.223-2.448zm-4.207 4.198L2.552 25c.197-.01.411-.053.61-.17l9.855-5.71 4.63-2.669-3.239-3.229z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgCommonIconAndroidFilled;